import styled from "styled-components";
import React, { useState, useCallback } from "react";
import Logo from "./components/Logo";
import ConnectButton from "./components/ConnectButton"
import Airdrop from '@/assets/svg/airdrop.svg'
import { ReactSVG } from 'react-svg'

export default function NavBar() {
  return (
    <StyledTopBar>
      <StyledTopBarInner>
        <StyledLeftMenuWrapper>
          <Logo/>
          <ReactSVG className="airdrop" src={Airdrop} beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex')}}/>
        </StyledLeftMenuWrapper>
        <StyledRightMenuWrapper>
          <ConnectButton/>
        </StyledRightMenuWrapper>
      </StyledTopBarInner>
    </StyledTopBar>
  )
}

const StyledTopBar = styled.div`
  display:fixed;
  top:0;
  left:0;  
`;

const StyledTopBarInner = styled.div`
  width: 100%;
  display:flex;
  box-sizing:border-box;
  justify-content: space-between;
  align-items: center;  
  padding: 21px 24px 0;
`;

const StyledLeftMenuWrapper = styled.div`  
  display: flex;
  align-items: center;
  .airdrop{
    margin-left: 21px;
    position: relative;
    top: 1px;
  }
`
const StyledRightMenuWrapper = styled.div`  
    
`
